import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// ✅ YENİ: Oluşturduğumuz CartProvider'ı import ediyoruz
import { CartProvider } from './contexts/CartContext';

// Sayfalar
import HomePage from './pages/HomePage.tsx';
import UploadOnlyPage from './pages/UploadOnlyPage';
import OwnerLogin from './pages/OwnerLogin';
import WeddingPage from './pages/WeddingPage';
import OwnerLogout from './pages/OwnerLogout';
import AdminPage from './pages/AdminPage';
import SweepstakesPage from "pages/SweepstakesPage";
import PackagesPage from "pages/PackagesPage";
import BaskiPage from './pages/BaskiPage';
import OdemePage from './pages/OdemePage';
import SiparisOnayPage from 'pages/SiparisOnayPage';
import AdresBilgileriPage from './pages/AdresBilgileriPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ContactPage from './pages/ContactPage';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute'; // <-- BU SATIRI EKLEYİN
import TeslimatIade from './pages/TeslimatIade';
import Hakkimizda from './pages/Hakkimizda';
import MesafeliSatis from './pages/MesafeliSatis';
// import BlogPage from "./pages/BlogPage";
import CalculatorPage from './pages/CalculatorPage';
import WhatsAppButton from './components/WhatsAppButton';
import OrderCountPopup from './components/OrderCountPopup';
import OrgDashboard from './pages/organization/OrgDashboard';
import OrgBuyPackage from './pages/organization/OrgBuyPackage';
// import TopBanner from './components/TopBanner'; // ✅ YENİ: Top Banner eklendi

export default function App() {
  return (
    <BrowserRouter>
      {/* <TopBanner /> */}
      <ScrollToTop />             {/* ← tam burada */}
      <WhatsAppButton />
      <OrderCountPopup />

      {/* ✅ YENİ: Tüm uygulama artık sepet verilerine erişebilir */}
      <CartProvider>
        <Routes>
          {/* Ana sayfa olarak yeni tanıtım sayfasını gösterir */}
          <Route path="/" element={<HomePage />} />

          {/* --- Mevcut Uygulama Rotaları --- */}
          <Route path="/w/:code" element={<UploadOnlyPage />} />
          <Route path="/owner/login" element={<OwnerLogin />} />
          <Route path="/owner/logout" element={<OwnerLogout />} />
          <Route
            path="/owner/w/:code"
            element={
              <ProtectedRoute> {/* Giriş yapmamışsa /owner/login'e yönlendir */}
                <WeddingPage />
              </ProtectedRoute>
            }
          />     

          <Route path="/yonetici-paneli-pa2ea4s-kx2-37g" element={<AdminPage />} />
          
          {/* ✅ ORGANİZASYON ROTALARI */}
          <Route path="/organization/login" element={<OwnerLogin />} />
          <Route path="/organization/dashboard" element={<ProtectedRoute><OrgDashboard /></ProtectedRoute>} />
          <Route path="/organization/satin-al" element={<ProtectedRoute><OrgBuyPackage /></ProtectedRoute>} />

          <Route path="/cekilis" element={<SweepstakesPage />} />
          <Route path="/paketler" element={<PackagesPage />} />
          <Route path="/baski" element={<BaskiPage />} />
          <Route path="/fiyat-hesapla" element={<CalculatorPage />} />
          <Route path="/adres-bilgileri" element={<AdresBilgileriPage />} />

          <Route path="/odeme" element={<OdemePage />} />
          <Route path='/siparis-onay/' element={<SiparisOnayPage />} />
          <Route path="/gizlilik-politikasi" element={<PrivacyPolicyPage />} />
          <Route path="/kosullar" element={<TermsOfServicePage />} />
          <Route path="/mesafeli-satis-sozlesmesi" element={<MesafeliSatis />} />
          <Route path="/mesafeli-satis" element={<MesafeliSatis />} />
          <Route path="/hakkimizda" element={<Hakkimizda />} />
          <Route path="/teslimat-iade-sartlari" element={<TeslimatIade />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/sifremi-unuttum" element={<ForgotPasswordPage />} />
          <Route path="/owner/sifre-sifirla/:resetToken" element={<ResetPasswordPage />} />

          {/* <Route path="/blog" element={<BlogPage />} /> */}

          {/* Bilinmeyen adresleri ana sayfaya yönlendirir */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </CartProvider>
    </BrowserRouter>
  );
}